import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $AppointmentCalendarScreen = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin-bottom: ${spacing('lg')};
`;

export const $UnderlinedRow = styled.div<{ $columnCount: number }>`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.default}`};
  padding: ${spacing(2.5)} 0;
  margin-bottom: ${spacing('lg')};
  position: relative;

  display: grid;
  grid-template-columns: repeat(${({ $columnCount }) => $columnCount}, 1fr);
  gap: ${spacing('lg')};
`;

export const $TimeSlotSelectorContainer = styled.div<{ $columnCount: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columnCount }) => $columnCount}, 1fr);
  gap: ${spacing('lg')};
  margin-bottom: ${spacing('lg')};
`;

export const $EmptyDay = styled.div`
  text-align: center;
  font-weight: ${fontWeight('bold')};
  color: ${({ theme }) => theme.colors.paragraphTextColor};
`;

export const $TagContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
  margin-top: ${spacing('lg')};

  > span {
    max-width: ${spacing(96)};
  }
`;
